import {createSlice} from "@reduxjs/toolkit";
import {RootState} from "../store";
import {RoutingState} from "../type/routing-state";
import {setRoutingSummaryDispatch} from "../dispatch/routing/set-routing-summary";
import {clearRoutingSummaryDispatch} from "../dispatch/routing/clear-routing-summary";

const initialState: RoutingState = {
    monthlyLogs: undefined,
    loading: false,
    error: null,
};

export const routingSlice = createSlice({
    name: "routingSlice",
    initialState,
    reducers: {
        clearRoutingSummaryAction: clearRoutingSummaryDispatch,
    },
    extraReducers: (builder) => {
        builder
            .addCase(setRoutingSummaryDispatch.pending, (state) => {
                state.loading = true;
            })
            .addCase(setRoutingSummaryDispatch.fulfilled, (state, action) => {
                state.loading = false;
                state.monthlyLogs = action.payload;
            })
            .addCase(setRoutingSummaryDispatch.rejected, (state, action) => {
                state.loading = false;
            });
    },
});

export const {
    clearRoutingSummaryAction
} = routingSlice.actions;

export const routingState = (state: RootState) => state.routing;

export default routingSlice.reducer;
